import React, { useEffect, useState } from "react";
import { Bookmark, Trash2, Play } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { describeFilter } from "@/lib/filters";
import { useNavigate } from "react-router-dom";

export default function SavedScansPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/saved-scans"); setItems(data.items || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/saved-scans/${id}`);
      setItems((prev) => prev.filter((i) => i.id !== id));
      toast.success("Silindi");
    } catch { toast.error("Silinemedi"); }
  };

  return (
    <div className="space-y-6" data-testid="saved-scans-page">
      <div>
        <h1 className="text-2xl font-semibold text-text-primary ztan-title">Kayıtlı Taramalar</h1>
        <p className="text-sm text-text-secondary mt-1">Kaydettiğiniz strateji filtreleri</p>
      </div>

      {loading ? (
        <div className="p-16 flex justify-center"><div className="radar-loader" /></div>
      ) : items.length === 0 ? (
        <div className="bg-bg-panel border border-bg-border rounded-xl p-16 text-center">
          <Bookmark size={32} className="text-text-secondary mx-auto mb-3" />
          <h3 className="text-text-primary font-semibold mb-1">Henüz kayıtlı strateji yok</h3>
          <p className="text-sm text-text-secondary">Teknik Tarama sayfasından strateji kaydedebilirsiniz.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it) => (
            <div key={it.id} className="bg-bg-panel border border-bg-border hover:border-brand-blue/60 rounded-xl p-5 group transition-all">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="text-base font-semibold text-text-primary group-hover:text-brand-blueLight transition-colors">{it.name}</div>
                  <div className="text-xs text-text-secondary mt-0.5 uppercase tracking-wider">{it.universe}</div>
                </div>
                <button onClick={() => remove(it.id)} className="text-text-secondary hover:text-signal-down">
                  <Trash2 size={14} />
                </button>
              </div>
              <div className="flex flex-wrap gap-1.5 my-3 min-h-[40px]">
                {it.filters.map((f, i) => (
                  <span key={i} className="bg-bg-base border border-bg-border text-text-secondary text-xs px-2 py-0.5 rounded">
                    {describeFilter(f)}
                  </span>
                ))}
              </div>
              <button
                onClick={() => {
                  sessionStorage.setItem("ztan_preset", JSON.stringify({ universe: it.universe, filters: it.filters }));
                  nav("/");
                }}
                className="bg-brand-blue text-white text-xs font-semibold py-2 px-3 rounded-lg w-full flex items-center justify-center gap-1.5 hover:bg-brand-blue/90"
              >
                <Play size={12} /> Bu Stratejiyi Çalıştır
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
